import React, {useEffect, useState} from 'react';
import { styled } from "styled-components";
import ReCAPTCHA from "react-google-recaptcha-enterprise";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import Button from "../button/button";

import ConfirmationSmsCode from "./confirmationSmsCode";
import ErrorMessage from "../messages/error";
import apiService from "../../data/service/apiService";
import useUserStore from "../../data/store/useUserStore";
import { t } from 'ttag';

const FormBox = styled.div`
  .proceed {
    p {
      color: #A9A9A9;
      font-size: 12px;
      line-height: 150%;
    }
  }
  .termsBlock {
    display: flex;
    
    input[type="checkbox"] {
      margin-right: 10px;
    }
    
    p {
      margin: 0;
      padding-left: 5px;
      padding-right: 5px;
    }
    
    a {
      color: #9738FF;
      margin-left: 5px;
    }
  }
  .wrongData {
    color: #F7326D;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .phoneInp {
    margin-bottom: 20px;
    input {
      background-color: #F5F5F5;
      padding: 10px 15px;
      margin: 10px;
      border: 0px;
      margin-left: 0px;
      padding-left: 50px;
    }
  }
  .phoneInp.error {
    input {
      color: #F7326D;
      font-variant-numeric: lining-nums proportional-nums;
      font-family: Raleway;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      
      border-radius: 5px !important;
      border: 1px solid #F7326D !important;
      background: #FDF2F4 !important;
    }
    .flag-dropdown {
      border: 1px solid #F7326D !important;
    }
  }
`;

const PhoneNumberForm = ({ onSubmit }) => {
  const recaptchaRef = React.useRef();
  const { setUserInfo } = useUserStore();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const [showConfirmationForm, setShowConfirmationForm] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [isLocalhost, setIsLocalhost] = useState(false);

  const handlePhoneNumberChange = (phone) => {
    setPhoneNumber(phone);
    setIsValid(true);
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const onSave = () => {
    const phonePattern = /^(\d{10}|\d{3}[-\s]\d{3}[-\s]\d{4}|\(\d{3}\)\s?\d{3}[-\s]\d{4}|\(\d{3}\)\s?\d{3}[-\s]\d{4}|\d{3}[-\s]\d{4}[-\s]\d{3}|\(\d{3}\)\s?\d{4}[-\s]\d{3})/;
    const isValidPhoneNumber = phonePattern.test(phoneNumber);

    setDisabledBtn(true);
    setIsValid(isValidPhoneNumber);

    if (isValidPhoneNumber) {
      apiService.post('/auth/code', {
        phoneNumber: phoneNumber,
        captchaToken: !isLocalhost ? captchaValue : '*6#xZ4fGH2H7*tVs'
      }).then(data => {
        setUserInfo({ phone: phoneNumber });
        setDisabledBtn(false);
      }).catch(err => {
        console.log('err >> ', err);
        setDisabledBtn(false);
      });

      setShowConfirmationForm(true);
    }
  };

  const goBack = () => {
    setShowConfirmationForm(false);
    setPhoneNumber('');
    setCaptchaValue(null);
    setIsValid(true);
  };

  const handleCheckboxChange = () => setIsAgreed(!isAgreed);

  useEffect(() => {
    setIsLocalhost(window.location.hostname === 'localhost');
  }, []);

  return !showConfirmationForm ? (
    <FormBox>
      <h2>{t`Enter your Phone number`}</h2>
      <div className='row'>
        <label htmlFor="phoneInput"><p>{t`Please provide your phone number to access your submitted cases`}</p></label>
        <PhoneInput
          className={!isValid ? 'phoneInp error' : 'phoneInp'}
          inputProps={{
            name: 'phone',
            required: true,
            autoFocus: true
          }}
          country={'us'}
          id="phoneInput"
          placeholder={t`Enter phone number`}
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
        />
      </div>
      {!isValid && phoneNumber && <ErrorMessage text={t`Wrong phone format`} />}
      <div className='row proceed'>
        <p>{t`Standard messaging charges apply`}.</p>
      </div>
      <div className='mt-2 termsBlock'>
        <input type="checkbox" checked={isAgreed} onChange={handleCheckboxChange} />
        <p>{t`I agree with the`}</p>
        <a href='https://www.easyllama.com/terms-anonymous' rel='noreferrer' target='_blank'>{t`Terms & Conditions`}</a>
        <p>{t`and`}</p>
        <a href='https://www.easyllama.com/privacy/' rel='noreferrer' target='_blank'>{t`Privacy Policy`}</a>
      </div>
      <div className='row mt-3 mb-3'>
      {!isLocalhost && (
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6Lf1kB4pAAAAAIIqUkapTWgSt8azEEUtHPG5coXz"
          onChange={handleCaptchaChange}
          invisible="true"
        />
      )}
      </div>
      <Button title='Proceed' onClick={onSave} disabled={!phoneNumber || !isAgreed || disabledBtn || (!isLocalhost && !captchaValue)} />
      <div className='row mt-3 proceed'>
        <p>{t`By providing your phone number and clicking the "Proceed" button, you consent to receive automated  text messages and/or phone calls from EasyLlama at the number you have provided.`}</p>
      </div>
    </FormBox>
  ) : <ConfirmationSmsCode onSubmit={onSubmit} phoneNumber={phoneNumber} goBack={goBack} />;
};

export default PhoneNumberForm;
